import { Component, Input, OnDestroy, OnInit, QueryList, ViewChildren } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { WindowService } from "@merri/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EventContextService } from "src/app/features/events";
import { VisionboardTemplate } from "../../models";
import { VisionboardWorkspaceTemplateService } from "../../services";
import { VisionboardWorkspaceTemplateLaneComponent } from "../visionboard-workspace-template-lane/visionboard-workspace-template-lane.component";

@Component({
    selector: "app-visionboard-workspace-template",
    templateUrl: "./visionboard-workspace-template.component.html",
    styleUrls: ["./visionboard-workspace-template.component.scss"],
    standalone: false
})
export class VisionboardWorkspaceTemplateComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();

  @ViewChildren(VisionboardWorkspaceTemplateLaneComponent) lanes: QueryList<VisionboardWorkspaceTemplateLaneComponent>;

  @Input() template: VisionboardTemplate;
  multiLaneMode: boolean;
  preferredVendorCompact: boolean;
  showVendorBanner: boolean;

  constructor(
    private windowService: WindowService,
    public matDialog: MatDialog,
    private visionboardWorkspaceTemplateService: VisionboardWorkspaceTemplateService,
    private eventContextService: EventContextService,
  ) {}

  ngOnInit() {
    this.multiLaneMode = this.template.lanes.length > 1;
    this.showVendorBanner = this.eventContextService.isUserEvent();

    this.windowService
      .observeMax$(700)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: result => {
          this.preferredVendorCompact = result.matches;
        },
      });

    this.visionboardWorkspaceTemplateService.showCategory$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: key => {
        const lane = this.lanes.find(i => i.lane.categories[key[0]] && !!i.lane.categories[key[0]].includes(key[1]));

        if (lane) {
          lane.promptLaneItemSelection(true);
        }
      },
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
